import {
  RESERVATION_FETCH_SHOP_CITIES,
  RESERVATION_CHANGE_CITY,
  RESERVATION_FETCH_SHOP_CITY_LIST,
  RESERVATION_FORM_OPEN,
  RESERVATION_FORM_CLOSE,
} from '../actions/Reservation.js';

import mapImage01 from '../static/images/taiwan-01.png';
import mapImage02 from '../static/images/taiwan-02.png';
import mapImage03 from '../static/images/taiwan-03.png';
import mapImage04 from '../static/images/taiwan-04.png';
import mapImage05 from '../static/images/taiwan-05.png';
import mapImage06 from '../static/images/taiwan-06.png';
import mapImage07 from '../static/images/taiwan-07.png';
import mapImage08 from '../static/images/taiwan-08.png';
import mapImage09 from '../static/images/taiwan-09.png';
import mapImage10 from '../static/images/taiwan-10.png';
import mapImage11 from '../static/images/taiwan-11.png';
import mapImage12 from '../static/images/taiwan-12.png';
import mapImage13 from '../static/images/taiwan-13.png';
import mapImage14 from '../static/images/taiwan-14.png';
import mapImage15 from '../static/images/taiwan-15.png';
import mapImage16 from '../static/images/taiwan-16.png';
import mapImage17 from '../static/images/taiwan-17.png';


const mapList = {
  基隆市: mapImage01,
  台北市: mapImage02,
  新北市: mapImage03,
  桃園市: mapImage04,
  新竹市: mapImage05,
  新竹縣: mapImage06,
  苗栗縣: mapImage07,
  台中市: mapImage08,
  彰化縣: mapImage09,
  南投縣: mapImage10,
  雲林縣: mapImage11,
  嘉義市: mapImage12,
  台南市: mapImage13,
  高雄市: mapImage14,
  屏東縣: mapImage15,
  金門縣: mapImage16,
  宜蘭縣: mapImage17,
};

export default (state = {
  cities: [],
  cityList: [],
  selectedCityMap: null,
  isFormModalOpen: false,
  selectedShop: null,
}, action) => {
  switch (action.type) {
    case RESERVATION_FETCH_SHOP_CITIES:
      if (action.list.length) {
        try {
          const city = action.list.find((d) => d.id === action.list[0].id);
          const listKey = Object.keys(mapList).find((key) => (key === city.name));

          if (listKey) {
            return Object.assign({}, state, {
              cities: action.list,
              selectedCityMap: mapList[listKey],
            });
          }
        } catch (e) {
          console.log(e);
        }
      }
      return Object.assign({}, state, {
        selectedCityMap: null,
      });


    case RESERVATION_CHANGE_CITY:
      if (state.cities.length) {
        try {
          const city = state.cities.find((d) => d.id === action.cityId);
          const listKey = Object.keys(mapList).find((key) => (key === city.name));

          if (listKey) {
            return Object.assign({}, state, {
              selectedCityMap: mapList[listKey],
            });
          }
        } catch (e) {
          console.log(e);
        }
      }
      return Object.assign({}, state, {
        selectedCityMap: null,
      });

    case RESERVATION_FETCH_SHOP_CITY_LIST:
      return Object.assign({}, state, {
        cityList: action.list,
      });

    case RESERVATION_FORM_OPEN:
      return Object.assign({}, state, {
        isFormModalOpen: true,
        selectedShop: action.shop,
      });

    case RESERVATION_FORM_CLOSE:
      return Object.assign({}, state, {
        isFormModalOpen: false,
        selectedShop: null,
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/Reservation.js